/* eslint-disable react/prop-types */
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router";
import { useQuery, useLazyQuery } from "@apollo/client";
import { Box } from "@material-ui/core";
import {
  GET_USER_COURSE_PURCHASES,
  GET_USER_COURSE_PURCHASES_NEXT,
  GET_USER_COURSE_PURCHASES_PREV,
} from "graphql/query/admin";
import Table from "Components/Table/Table";

const CoursesTab = ({ userId }) => {
  const navigate = useNavigate();
  const [purchases, setPurchases] = useState([]);
  const [pageInfo, setPageInfo] = useState("");
  const [page, setPage] = useState(0);

  const { data, error, loading } = useQuery(GET_USER_COURSE_PURCHASES, {
    variables: {
      userId,
      first: 10,
      orderBy: "createdAt_DESC",
    },
    fetchPolicy: "network-only",
    skip: !userId,
  });

  const [getNextPage, { loading: nextLoader }] = useLazyQuery(GET_USER_COURSE_PURCHASES_NEXT);
  const [getPrevPage, { loading: prevLoader }] = useLazyQuery(GET_USER_COURSE_PURCHASES_PREV);

  const mapEdges = (edges) =>
    edges.map((e) => ({
      ...e.node,
      courseName: e.node.course?.name || "N/A",
      courseType: e.node.course?.type || "N/A",
      courseTag: e.node.course?.tag || "N/A",
    }));

  const handleNextPage = async () => {
    if (pageInfo.hasNextPage) {
      const res = await getNextPage({
        variables: { userId, first: 10, after: pageInfo.endCursor, orderBy: "createdAt_DESC" },
        fetchPolicy: "network-only",
      });
      if (res.data?.userCoursePurchases) {
        setPurchases(mapEdges(res.data.userCoursePurchases.edges));
        setPage(page + 1);
        setPageInfo(res.data.userCoursePurchases.pageInfo);
      }
    }
  };

  const handlePreviousPage = async () => {
    if (pageInfo.hasPreviousPage) {
      const res = await getPrevPage({
        variables: { userId, last: 10, before: pageInfo.startCursor, orderBy: "createdAt_DESC" },
        fetchPolicy: "network-only",
      });
      if (res.data?.userCoursePurchases) {
        setPurchases(mapEdges(res.data.userCoursePurchases.edges));
        setPage(page - 1);
        setPageInfo(res.data.userCoursePurchases.pageInfo);
      }
    }
  };

  useEffect(() => {
    if (data?.userCoursePurchases) {
      setPurchases(mapEdges(data.userCoursePurchases.edges));
      setPageInfo(data.userCoursePurchases.pageInfo);
    }
    setPage(0);
  }, [data]);

  const handleViewButton = (id) => {
    const purchase = purchases.find((p) => p.id === id);
    navigate("/admin/user/view-course-purchase", { state: { purchaseId: id, userId, purchase } });
  };

  const TABLE_HEAD = [
    { id: "id", flag: "id", label: "No.", alignRight: false },
    { id: "courseName", flag: "courseName", label: "Course Name", alignRight: false },
    { id: "courseType", flag: "courseType", label: "Type", alignRight: false },
    { id: "courseTag", flag: "courseTag", label: "Tag", alignRight: false },
    { id: "price", flag: "price", label: "Price", alignRight: false },
    { id: "createdAt", flag: "createdAt", label: "Purchased At", alignRight: false },
    {
      id: "actions",
      flag: { read: true },
      callback: { handleViewButton },
      label: "Actions",
      alignRight: false,
    },
  ];

  return (
    <Box style={{ padding: "16px 0" }}>
      <Table
        error={error}
        USERLIST={purchases}
        page={page}
        handleNextPage={handleNextPage}
        handlePreviousPage={handlePreviousPage}
        TABLE_HEAD={TABLE_HEAD}
        pageInfo={pageInfo}
        loading={loading || nextLoader || prevLoader}
      />
    </Box>
  );
};

export default CoursesTab;
